import { render, staticRenderFns } from "./ConsultationsInWard.vue?vue&type=template&id=7112c34a&scoped=true&"
import script from "./ConsultationsInWard.vue?vue&type=script&lang=js&"
export * from "./ConsultationsInWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7112c34a",
  null
  
)

export default component.exports